<div class="payment-method-vcc-container wiki">
    <app-system-picture [systemId]="system.id" [alt]="system.attributes.name" title="Comprar/Vender {{system.attributes.name}}"></app-system-picture>
    <p><b *ngIf="amount">{{formatDecimalsHelper.formatDecimal( amount , system.attributes.decimal_places) }}</b><span> {{ system.attributes.currency }}</span></p>


</div>
